import { clientDetection } from '../app/shared/globalFunctions/globalFunctions';
import { baseEnvironment } from './environment.base';

export const environment = {
    ...baseEnvironment,
    API_URL: {
        CNMI: 'https://cnmiuat.newworldnow.com/v7/api',
        MI: 'https://miuat.newworldnow.com/v7/api',
        MN: 'https://mnuat.newworldnow.com/v7/api',
        MO: 'https://mouat.newworldnow.com/v7/api',
        MT: 'https://mtuat.newworldnow.com/v7/api',
        ND: 'https://nduat.newworldnow.com/v7/api',
        NY: 'https://nyuat.newworldnow.com/v7/api',
        OK: 'https://okuat2.newworldnow.com/v7/api',
        PA: 'https://pauat2.newworldnow.com/v7/api',
        PAEI: 'https://paeiuat.newworldnow.com/v7/api',
        SC: 'https://scuat.newworldnow.com/v7/api',
        WI: 'https://wiuat.newworldnow.com/v7/api',
    } as { [key: string]: string },
    authority: 'https://identityuat.newworldnow.com',
    redirectUrl: `https://${clientDetection().toLowerCase()}-uat.rostersync.newworldnow.com/callback`,
    clientId: `Training Provider ${clientDetection()} PWA(Uat)`, //CREATE MAPPING BETWEEN REDIRECT AND CLIENT ID
};
